<template>
    <el-form :model="bankAcct" :rules="bankAcctRules" :label-position="'left'" ref="bankAcctInfo">
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">所属公司</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="realComId">
                        <el-input class="width-1-5x bottom-line" disabled type="text" v-model="bankAcct.realComName"></el-input>
                        <div class="form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择" @click="selectRealComId()"></div>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">用途</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="usage">
                        <el-select v-model="bankAcct.usage" placeholder="请选择">
                            <el-option v-for="item in bankAcctUsageList" :key="item.value" :label="item.text" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">所属银行</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="bankName">
                        <el-input v-model="bankAcct.bankName" placeholder="请输所属银行"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">银行代码</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="bankCode">
                        <el-input v-model="bankAcct.bankCode" placeholder="请输银行代码"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">银行卡号</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="cardNo">
                        <el-input v-model="bankAcct.cardNo" placeholder="请输银行卡号"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">银行账号名称</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="acctName">
                        <el-input v-model="bankAcct.acctName" placeholder="请输银行账号名称"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">银行账号</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="acctNo">
                        <el-input v-model="bankAcct.acctNo" placeholder="请输银行账号"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>打款验证码</label>
                </div>
                <div class="form-value  width-1-5x">
                    <el-form-item prop="code">
                        <el-input v-model="bankAcct.vfCode" placeholder="请输打款验证码"></el-input>
                    </el-form-item>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'
    import merchtComnApi from '../../api/merchtComn.js'
    import { selectRealComDlg } from '../comn/dialog'
    import { selectMerchantRealComDlg } from '../realCom/dialog'

    export default {
        name: 'swb-real-com-bank-acct-save',
        desc: '',
        props: ["id", "realComId"],
        data: function () {
            let checkNull = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            };
            let checkCardNo = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    if(value.length < 9 || value.length > 20) {
                        callback(new Error('请输入正确的银行卡号，长度大于8小于21'));
                    } else {
                        callback();
                    }
                }
            };
            let checkAcctNo = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    if(value.length < 9 || value.length > 20) {
                        callback(new Error('请输入正确的银行卡号，长度大于8小于21'));
                    } else {
                        callback();
                    }
                }
            };
            return {
                bankAcct: {},
                bankAcctUsageList: getEnumList('bankAcctUsage'),
                bankAcctRules: {
                    realComId: [{validator: checkNull, trigger: 'blur'}],
                    usage: [{validator: checkNull, trigger: 'blur'}],
                    bankCode: [{validator: checkNull, trigger: 'blur'}],
                    bankName: [{validator: checkNull, trigger: 'blur'}],
                    cardNo: [{validator: checkCardNo, trigger: 'blur'}],
                    acctNo: [{validator: checkAcctNo, trigger: 'blur'}],
                    acctName: [{validator: checkNull, trigger: 'blur'}],
                }
            }
        },
        created: function () {
            let self = this;
            if(!Utils.isNoB(self.id)) {
                self.getBankAcctById()
            } else {
                this.getRealCom();
            }
        },
        methods: {
            getRealCom(){
                let self = this;
                let postData = {};
                postData.id = this.realComId;
                let theLoading = MsgBox.loading();
                merchtComnApi.getRealCom(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        let realCom = result.data;
                        //
                        let bankAcct = self.bankAcct;
                        bankAcct.realComId = realCom.id;
                        bankAcct.realComName = realCom.name;
                        self.bankAcct = Utils.merge({}, bankAcct);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            selectRealComId: function () {
                let self = this;
                let bankAcct = self.bankAcct;
                selectMerchantRealComDlg({}, function (result) {
                    bankAcct.realComId = result.id;
                    bankAcct.realComName = result.name;
                    self.bankAcct = Utils.merge({}, bankAcct);
                })
            },
            getBankAcctById: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                merchtComnApi.getRealComBankAcctById(postData, function (result) {
                    if(result.type == "info") {
                        self.bankAcct = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            getResult: function () {
                // 提供回调函数，返回结果
                let self = this;
                let result = {};
                this.$refs['bankAcctInfo'].validate(function (valid) {
                    if(valid) {
                        result.type = "info";
                        result.data = self.bankAcct;
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/merchtFinac/RealComBankAcctSave.vue